import PulseLoader from "react-spinners/PulseLoader";
import tailwindTheme from "@/styles/tailwind.theme";

const LoadingPulse = ({ className = "" }: { className?: string }) => {
  const colors = tailwindTheme.theme.colors;

  return (
    <div
      className={`flex h-full w-full items-center justify-center ${className}`}
    >
      <PulseLoader color={colors.blue[100]} />
    </div>
  );
};

export default LoadingPulse;
